import { create } from "zustand";

export type Step = {
    id: string;
    label: string;
};

type StepsState = {
    steps: Step[];
    currentStepIndex: number;
};

type StepsActions = {
    setSteps: (steps: Step[]) => void;
    next: () => void;
    back: () => void;
    goTo: (index: number) => void;
};

export const useStepsStore = create<StepsState & StepsActions>()(
    (set, get) => ({
        steps: [],
        currentStepIndex: 0,
        setSteps: (steps) => set({ steps }),
        next: () => {
            const { currentStepIndex, steps } = get();
            if (currentStepIndex < steps.length - 1) {
                set({ currentStepIndex: currentStepIndex + 1 });
            }
        },
        back: () => {
            const { currentStepIndex } = get();
            if (currentStepIndex > 0) {
                set({ currentStepIndex: currentStepIndex - 1 });
            }
        },
        goTo: (index) => {
            const { steps } = get();
            if (index >= 0 && index < steps.length) {
                set({ currentStepIndex: index });
            }
        },
    }),
);
